import http, { expandURI } from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'
import {
  PROPOSAL_INIT_LOADING,
  PROPOSAL_INIT_SUCCESS,
  PROPOSAL_INIT_FAIL,
  PROPOSAL_LISTING_LOADING,
  PROPOSAL_LISTING_SUCCESS,
  PROPOSAL_LISTING_FAIL,
  PROPOSAL_DETAILS_INIT_LOADING,
  PROPOSAL_DETAILS_INIT_SUCCESS,
  PROPOSAL_DETAILS_INIT_FAIL,
  PROPOSAL_DETAILS_LOAD_DATA,
  PROP_COVER_DET_INIT_LOADING,
  PROP_COVER_DET_INIT_SUCCESS,
  PROP_COVER_DET_INIT_FAIL
} from '@/store/types'

export const general = {
  async proposalInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.proposal
    if (apiUrl) {
      commit(PROPOSAL_INIT_LOADING)
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu: menu
        }
        commit(PROPOSAL_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(PROPOSAL_INIT_FAIL, extractMessages(error))
      }
    } else {
      commit(PROPOSAL_INIT_FAIL, extractMessages(['The request failed because it is trying to execute an invalid API url.']))
    }
  },
  async proposalListingInit({ commit, state }) {
    const apiUrl = state.menu.proposalListing
    if (apiUrl) {
      commit(PROPOSAL_LISTING_LOADING)
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = result.data
        Object.assign(commitResult, {
          menu: menu
        })
        commit(PROPOSAL_LISTING_SUCCESS, commitResult)
      } catch (error) {
        commit(PROPOSAL_LISTING_FAIL, extractMessages(error))
      }
    } else {
      commit(PROPOSAL_LISTING_FAIL, extractMessages(['The request failed because it is trying to execute an invalid API url.']))
    }
  },
  async proposalDetailsInit({ commit, state }) {
    const apiUrl = state.menu.proposalDetails
    if (apiUrl) {
      commit(PROPOSAL_DETAILS_INIT_LOADING)
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = result.data
        Object.assign(commitResult, {
          menu: menu
        })
        commit(PROPOSAL_DETAILS_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(PROPOSAL_DETAILS_INIT_FAIL, extractMessages(error))
      }
    } else {
      commit(PROPOSAL_DETAILS_INIT_FAIL, extractMessages(['The request failed because it is trying to execute an invalid API url.']))
    }
  },
  async coverageDetailsInit({ commit, state }) {
    const apiUrl = state.menu.coverageDetails
    if (apiUrl) {
      commit(PROP_COVER_DET_INIT_LOADING)
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = result.data
        Object.assign(commitResult, {
          menu: menu
        })
        commit(PROP_COVER_DET_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(PROP_COVER_DET_INIT_FAIL, extractMessages(error))
      }
    } else {
      commit(PROP_COVER_DET_INIT_FAIL, extractMessages(['The request failed because it is trying to execute an invalid API url.']))
    }
  },
  async reviewProposal({ commit, state }, formData) {
    const apiUrl = state.proposalDetails.menu.getProposalDetails
    if (apiUrl) {
      try {
        const expand = {
          propNo: formData.propNo,
          ipcNo: formData.ipcNo,
          ipcSeqNo: formData.ipcSeqNo
        }
        const result = await http.get(expandURI(apiUrl, expand))

        if (result.data) {
          const { data } = result.data
          const commitObject = {
            data: data.propDetails
          }
          commit(PROPOSAL_DETAILS_LOAD_DATA, commitObject)
        } else {
          throw new Error('Invalid Fetch Result')
        }
      } catch (error) {
        throw error
      }
    } else {
      throw new Error('The request failed because it is trying to execute an invalid API url.')
    }
  }
}
